<template>
  <RepositoriesConfirm
    :repository
    action-type="delete"
    @cancel="emit('cancel')"
    @export="handleExport"
    @confirmed="emit('deleted', $event)"
  />
</template>

<script lang="ts" setup>
import { Repository } from '@types'
import RepositoriesConfirm from './RepositoriesConfirm.vue'

type Props = {
  repository: Repository
}

type Emits = {
  cancel: []
  export: [id: string, name: string, resolve: () => void, reject: () => void]
  deleted: [id: string]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleExport = (
  id: string,
  name: string,
  resolve: () => void,
  reject: () => void,
) => {
  emit('export', id, name, resolve, reject)
}
</script>
